<template lang="pug">
.register-body
  .register-row
    .register-group
      .register-key
        span.key-name 公開範囲
        span.validation-label 必須

      .register-value.radios
        label.register-radio-label
          input#type-0.register-radio-form(
            v-model="_value"
            name="event-target-type"
            type="radio"
            :value="0"
            v-validate="{ required: true }"
            data-vv-as="公開範囲")
          span.register-radio-text 施設全体
        label.register-radio-label
          input#type-1.register-radio-form(v-model="_value" name="event-target-type" type="radio" :value="1")
          span.register-radio-text 利用者グループ

      .error-messages(v-for="error in errors.collect('event-target-type')")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { EventTargetType } from "@/commons/services/Events";

/**
 * ### 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputEventTargetType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: EventTargetType;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): EventTargetType {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: EventTargetType) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.radios {
  flex-wrap: wrap;
}
</style>
